
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ganz einfach: Weil sie oft belanglos sind und für die Psyche deshalb uninteressant. Die schlechten Träume bleiben länger im Gedächtnis, weil sie uns mehr aufwühlen. `}<M mdxType="M">{`Gemäss Studien ist der Anteil von guten und bösen Träumen fast ausgeglichen, allerdings sind die guten weit weniger erforscht.`}</M>{` Der Grund: Therapeutisch ergibt es mehr Sinn, auf die problembehafteten Beispiele zu fokussieren, die auf psychischen Stress hinweisen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;